import CommunityPostingDto from '@/src/models/CommunityPostingDto';
import CommunityReportDto from '@/src/models/CommunityReportDto';
import { CustomersDto } from '@/src/models/CustomersDto';

export default class CommunityCommentDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;

  // 블라인드 일자
  blindProcessedAt?: string;

  // 내용
  content: string;

  // 작성자
  customer: CustomersDto;

  // 신고 상태
  communityReportType: string;

  // 신고 정보
  communityReport: CommunityReportDto;

  // 대상 게시글
  communityPosting: CommunityPostingDto;

  // 좋아요 수
  communityLikeCount: number;

  // 조회 수
  communityViewHistoryCount: number;

  // 지급 크레딧 정보
  communityActiveHistories: {
    createdAt: string;
    creditActionType: string;
    creditValue: number;
    deletedAt: string;
    id: number;
    updatedAt: string;
  };
}
